import React, { Component } from 'react';
import { array, bool, func, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NavLink, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { hideSlideout } from 'ps-components/Slideout/SlideoutReducer';
import { createDataTestId } from 'ps-components/lib/formatters';

import './NavSection.scss';

class NavSection extends Component {
  constructor(props) {
    super(props);

    let collapsed = window.localStorage.getItem(this.titleToKey(this.props.title));

    if (collapsed === null) {
      // when not set in localStorage, default to section closed
      collapsed = true;
    } else {
      // localStorage saves a string
      collapsed = collapsed === 'true';
    }

    this.state = {
      collapsed
    };

    this.toggleSection = this.toggleSection.bind(this);
    this.renderUrlLink = this.renderUrlLink.bind(this);
    this.reloadPage = this.reloadPage.bind(this);
  }

  titleToKey(title) {
    return title.toLowerCase().replace(' ', '');
  }

  toggleSection(event) {
    if (this.props.customHref) return;
    event.preventDefault();
    const collapsed = !this.state.collapsed;

    this.setState({
      collapsed
    });

    window.localStorage.setItem(this.titleToKey(this.props.title), collapsed);
  }

  renderActionLink(link, index) {
    return (
      <li className="nav-section__item" key={index}>
        <div className="nav-section__link nav-section__link-action" onClick={link.action}>
          {link.name}
        </div>
      </li>
    );
  }

  reloadPage(e) {
    this.props.actions.hideSlideout();
    // MPE-3975: Force refresh for group admin tabs
    // to fix issue with no refresh when switching between those tabs
    if (location.href.includes('group-admin-edit') && e.target.href.includes('group-admin-edit')) {
      location.href = e.target.href;
    } else if (e.target.href === window.location.href) {
      location.reload();
    }
  }

  renderUrlLink(link, index) {
    let absoluteUrl = false;
    if (typeof link.to === 'string' && (link.to.match('http') || link.to.includes('.pdf'))) {
      absoluteUrl = true;
    }

    return (
      <li className="nav-section__item" key={index}>
        {absoluteUrl ? (
          <a
            href={link.to}
            className={`nav-section__link ${link.isActive ? 'nav-section__link--active' : ''}`}
            target={link.target}
            onClick={this.props.actions.hideSlideout}
          >
            {link.name}
          </a>
        ) : (
          <NavLink
            className="nav-section__link"
            activeClassName="nav-section__link--active"
            to={link.to}
            exact
            isActive={link.isActive}
            target={link.target}
            onClick={this.reloadPage}
            data-test-id={createDataTestId(link.name, 'nav-link')}
          >
            {link.name}
          </NavLink>
        )}
      </li>
    );
  }

  renderLinks() {
    return this.props.links.map((link, index) => {
      if (link.visible) {
        if (link.action) {
          return this.renderActionLink(link, index);
        } else {
          return this.renderUrlLink(link, index);
        }
      }
    });
  }

  render() {
    const { icon, title } = this.props;
    const isCollapsed = this.state.collapsed;

    let height = !this.props.navCollapsed && isCollapsed ? '' : this.height;
    let navSectionLinksClassName = isCollapsed ? 'nav-section__links--collapsed' : 'nav-section__links';
    if (this.props.navCollapsed) navSectionLinksClassName = 'nav-section__links';

    let navSectionClassName = `${isCollapsed ? 'nav-section--collapsed' : 'nav-section'}`;
    const iconContainerClass = classNames({
      nav__icon: !this.props.iconHasCircle,
      ['icon-reverse']: this.props.iconHasCircle,
      ['icon-circle']: this.props.iconHasCircle,
      ['nav__icon--circle']: this.props.iconHasCircle
    });
    return (
      <div className={navSectionClassName}>
        <a
          href={this.props.customHref ? this.props.customHref : "#nogo"}
          className="nav-section__title"
          onClick={this.toggleSection}
          data-test-id={createDataTestId(title, 'nav-section')}
          target={this.props.customHref ? "_blank" : ""}
        >
          <div className={iconContainerClass}>
            {icon.endsWith('.svg') ? (
              <img src={icon} className="nav-section__icon" />
            ) : (
              <i className={icon} aria-hidden="true" />
            )}
            <span className="nav-section__name">{title}</span>
          </div>
        </a>
        <ul
          style={{ height: height }}
          className={navSectionLinksClassName}
          ref={list => {
            this.list = list;
          }}
        >
          {this?.props?.links && this.renderLinks()}
        </ul>
      </div>
    );
  }
}

NavSection.propTypes = {
  links: array,
  navCollapsed: bool,
  icon: string,
  title: string,
  iconHasCircle: bool,
  actions: shape({
    hideSlideout: func
  })
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      hideSlideout
    },
    dispatch
  )
});

export default withRouter(connect(null, mapDispatchToProps)(NavSection));
